<template>
  <div
    ref="bar"
    class="chart"></div>
</template>

<script>
import * as echarts from 'echarts'
import { getDateRangeArray } from 'src/utils/date'

export default {
  name: 'MallMonthDataDetailChart',
  props: {
    list: {
      type: Array,
      default: () => ([])
    },
    color: {
      type: String,
      default: '#1261FF'
    },
    barName: {
      type: String,
      default: ''
    },
    lineName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      bar: null
    }
  },
  watch: {
    list() {
      this.initBar()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initBar()
    })

    window.addEventListener('resize', () => {
      if (this.bar) this.bar.resize()
    })
  },
  beforeDestroy() {
    if (this.bar) this.bar.dispose()
    this.bar = null
  },
  methods: {
    initBar() {
      const { list } = this
      const lineData = []
      const barData = []
      const xData = getDateRangeArray(this.$moment().startOf('month').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD'), 'day')
      xData.forEach((date, i) => {
        const index = list.findIndex(i => {
          return i.date === date
        })
        if (index > -1) {
          const item = list[index]
          lineData.push(item.lineValue)
          barData.push(item.barValue)
        } else {
          lineData.push(0)
          barData.push(0)
        }
      })

      this.bar = echarts.init(this.$refs.bar)
      const option = {
        grid: {
          top: 58,
          right: 40,
          bottom: 0,
          left: 16,
          containLabel: true
        },
        color: this.color,
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          extraCssText: 'box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.1);border-radius: 4px;padding: 8px 12px;line-height: 24px;',
          textStyle: {
            color: '#333'
          },
          axisPointer: {
            lineStyle: {
              color: this.color
            },
            z: 2
          },
          formatter: function(params) {
            let result = ''
            let axisValue = ''
            params.forEach((item) => {
              axisValue = item.axisValue
              result += `
                <span>${item.seriesName}：</span>${item.data}</br>
              `
            })
            return `
              ${axisValue}</br>
              ${result}
            `
          }
        },
        xAxis: {
          name: '日期',
          nameTextStyle: {
            color: '#999',
            padding: [36, 0, 0, 0]
          },
          type: 'category',
          data: xData,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#999'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999',
            fontSize: 12,
            margin: 12,
            formatter: (v) => this.$moment(v).format('M.D')
          }
        },
        yAxis: [
          {
            name: this.barName,
            nameTextStyle: {
              color: '#999',
              fontSize: 12,
              padding: [0, 0, 8, 0]
            },
            type: 'value',
            max: value => +(value.max * 1.5).toFixed(0),
            axisLine: {
              show: true,
              lineStyle: {
                color: '#999'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#999',
              fontSize: 12,
              margin: 8
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#E6EBED'
              }
            }
          },
          {
            name: this.lineName,
            nameTextStyle: {
              color: '#999',
              fontSize: 12,
              padding: [0, 0, 8, 0]
            },
            type: 'value',
            // max: value => +(value.max * 1.1).toFixed(0),
            axisLine: {
              show: true,
              lineStyle: {
                color: '#999'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#999'
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: this.barName,
            yAxisIndex: 0,
            data: barData,
            type: 'bar',
            barMaxWidth: 20,
            itemStyle: {
              barBorderRadius: [4, 4, 0, 0]
            }
          },
          {
            name: this.lineName,
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            data: lineData,
            lineStyle: {
              opacity: 0.5
            },
            itemStyle: {
              opacity: 0
            }
          }
        ]
      }
      this.bar.setOption(option, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.chart {
    width: 100%;
    height: 100%;
}
</style>
